module.exports = __webpack_public_path__ + "static/kikiam-ba29fd25667d03a481c7878be59e73a1.jpg";